// extracted by mini-css-extract-plugin
module.exports = {"affirm":"PdpSharedAffirm__affirm__2fdba372","affirmInfo":"PdpSharedAffirm__affirmInfo__2fdba372"};